// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ✅ HomePage - Dashboard stylé (ShemsPaie) */

.home-page {
  color: var(--color-dark-brown);
}

/* ── Header ── */
.home-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 0.25rem 0 0.75rem;
}

.home-header-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.home-greeting {
  font-size: 1.45rem;
  font-weight: 800;
  color: var(--color-dark-brown);
  line-height: 1.2;
  display: flex;
  align-items: center;
  gap: 10px;
}

.home-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6d4e36, #9c6b45);
  color: #fff;
  font-size: 0.9rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  flex-shrink: 0;
  box-shadow: 0 3px 10px rgba(109, 78, 54, 0.3);
}

.home-subtitle {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 13px;
  color: #7a6a5c;
}

.home-date {
  font-size: 0.82rem;
  color: #9e8e7e;
  font-weight: 500;
  text-transform: capitalize;
}

.home-header-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

/* ── Dashboard container ── */
.home-dashboard {
  border: 1px solid rgba(109, 78, 54, 0.1);
  border-top: 3px solid #6d4e36;
  border-radius: 18px;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(109, 78, 54, 0.08);
}

/* ── Dashboard header row ── */
.home-dashboard-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 14px;
}

.home-dashboard-title {
  font-weight: 700;
  color: var(--color-dark-brown);
  opacity: 0.55;
  text-transform: uppercase;
  font-size: 10px;
  letter-spacing: 0.1em;
}

/* ── Search bar ── */
.home-search-wrap {
  position: relative;
  display: flex;
  align-items: center;
  flex: 0 1 260px;
}

.home-search-icon {
  position: absolute;
  left: 10px;
  color: #b0a090;
  font-size: 12px;
  pointer-events: none;
}

.home-search-input {
  width: 100%;
  padding: 6px 30px 6px 28px;
  border: 1.5px solid rgba(109, 78, 54, 0.18);
  border-radius: 10px;
  font-size: 0.82rem;
  color: var(--color-dark-brown);
  background: #fff;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.home-search-input:focus {
  border-color: rgba(109, 78, 54, 0.45);
  box-shadow: 0 0 0 3px rgba(109, 78, 54, 0.07);
}

.home-search-clear {
  position: absolute;
  right: 8px;
  background: none;
  border: none;
  color: #b0a090;
  font-size: 11px;
  cursor: pointer;
  padding: 2px 4px;
  line-height: 1;
  transition: color 0.15s;
}

.home-search-clear:hover {
  color: #6d4e36;
}

/* ── Section card ── */
.home-section-card {
  padding: 16px 0 0 0;
  animation: fadeSlideIn 0.3s ease both;
}

.home-section-card:first-of-type {
  padding-top: 0;
}

.home-section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.home-section-header::before,
.home-section-header::after {
  content: '';
  flex: 1 1;
  height: 1px;
  background: rgba(109, 78, 54, 0.1);
}

.home-section-title {
  font-weight: 700;
  font-size: 0.72rem;
  color: var(--color-dark-brown);
  display: flex;
  align-items: center;
  gap: 6px;
  opacity: 0.6;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.home-section-dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  flex-shrink: 0;
}

.home-section-count-badge {
  font-size: 0.6rem;
  font-weight: 700;
  color: #fff;
  border-radius: 20px;
  padding: 1px 6px;
  line-height: 1.5;
  opacity: 0.7;
}

/* ── Tile ── */
.home-tile {
  background: transparent;
  border: 1px solid rgba(109, 78, 54, 0.11);
  border-top: 2.5px solid var(--color-light-brown);
  border-radius: 12px;
  padding: 10px 10px 9px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.04);
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 7px;
  height: 100%;
  animation: fadeSlideIn 0.35s ease both;
  position: relative;
  overflow: hidden;
}

/* ↗ arrow on hover */
.home-tile::after {
  content: '↗';
  position: absolute;
  bottom: 7px;
  right: 9px;
  font-size: 0.75rem;
  font-weight: 700;
  opacity: 0;
  transform: translate(4px, -4px);
  transition: opacity 0.18s ease, transform 0.18s ease;
  color: var(--color-dark-brown);
}

.home-tile:hover::after {
  opacity: 0.3;
  transform: translate(0, 0);
}

.home-tile:hover {
  transform: translateY(-4px) scale(1.01);
  box-shadow: 0 10px 24px rgba(109, 78, 54, 0.14);
  border-color: rgba(109, 78, 54, 0.3);
}

.home-tile:active {
  transform: translateY(-1px) scale(0.99);
  transition-duration: 0.08s;
}

.home-tile-disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.home-tile-disabled:hover {
  transform: none;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.04);
}

.home-tile-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: transform 0.18s ease;
}

.home-tile:hover .home-tile-icon {
  transform: scale(1.12);
}

.home-tile-body {
  flex: 1 1;
}

.home-tile-title {
  font-weight: 800;
  font-size: 0.8rem;
  color: var(--color-dark-brown);
  line-height: 1.25;
}

.home-tile-desc {
  font-size: 0.7rem;
  margin-top: 2px;
  color: #a89880;
  line-height: 1.35;
}

.home-tile-soon {
  margin-top: 4px;
}

/* ── Animations ── */
@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

@keyframes fadeSlideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Stagger tiles inside each section */
.home-tile:nth-child(1)  { animation-delay: 0.00s; }
.home-tile:nth-child(2)  { animation-delay: 0.04s; }
.home-tile:nth-child(3)  { animation-delay: 0.08s; }
.home-tile:nth-child(4)  { animation-delay: 0.12s; }
.home-tile:nth-child(5)  { animation-delay: 0.16s; }
.home-tile:nth-child(6)  { animation-delay: 0.20s; }
.home-tile:nth-child(7)  { animation-delay: 0.24s; }
.home-tile:nth-child(8)  { animation-delay: 0.28s; }

/* KPI cards entrance */
.home-kpi-grid > div {
  animation: fadeSlideIn 0.4s ease both;
}

.home-kpi-grid > div:nth-child(1) { animation-delay: 0.05s; }
.home-kpi-grid > div:nth-child(2) { animation-delay: 0.12s; }
.home-kpi-grid > div:nth-child(3) { animation-delay: 0.19s; }
.home-kpi-grid > div:nth-child(4) { animation-delay: 0.26s; }

/* ── Responsive ── */
@media (max-width: 768px) {
  .home-greeting {
    font-size: 1.2rem;
  }
  .home-dashboard {
    padding: 14px 12px;
  }
  .home-search-wrap {
    flex: 1 1 100%;
  }
  .home-dashboard-header {
    gap: 0.75rem;
  }
}

@media (max-width: 575px) {
  /* Header : plus compact */
  .home-header {
    gap: 0.5rem;
  }
  .home-greeting {
    font-size: 1rem;
    gap: 7px;
  }
  .home-avatar {
    width: 34px;
    height: 34px;
    font-size: 0.78rem;
  }
  .home-date {
    display: none;
  }
  .home-header-actions .btn {
    font-size: 0.75rem;
    padding: 4px 8px;
  }

  /* Dashboard */
  .home-dashboard {
    padding: 12px 10px;
    border-radius: 14px;
  }

  /* KPI cards : 1 seule colonne sur téléphone */
  .home-kpi-grid {
    grid-template-columns: 1fr !important;
    gap: 10px !important;
  }

  /* Tiles : icône plus petite */
  .home-tile {
    padding: 8px 8px 7px;
    gap: 5px;
  }
  .home-tile-icon {
    width: 30px;
    height: 30px;
    border-radius: 8px;
  }
  .home-tile-icon svg {
    width: 18px;
    height: 18px;
  }
  .home-tile-title {
    font-size: 0.76rem;
  }
  .home-tile-desc {
    display: none;
  }

  /* Section header : texte plus compact */
  .home-section-title {
    font-size: 0.65rem;
  }

  /* Sélecteur période : inputs plus compacts */
  .home-period-bar {
    gap: 6px;
  }
  .home-period-inputs input[type="date"] {
    font-size: 0.72rem !important;
    padding: 4px 5px !important;
    min-width: 0;
    width: 100px;
  }
  .home-period-inputs span:first-child {
    padding: 4px 7px !important;
    font-size: 0.68rem !important;
  }
}

@media (max-width: 400px) {
  /* Très petits écrans */
  .home-tile-title {
    font-size: 0.72rem;
  }
  /* Sélecteur période : inputs en colonne */
  .home-period-inputs {
    flex-direction: column;
    align-items: stretch !important;
    width: 100%;
  }
  .home-period-inputs input[type="date"] {
    width: 100% !important;
  }
  .home-period-inputs span:nth-child(3) {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/HomePage.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C;EACE,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,wCAAwC;EACxC,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA,eAAe;AACf;EACE,uBAAuB;EACvB,yCAAyC;EACzC,gDAAgD;EAChD,mBAAmB;EACnB,sBAAsB;EACtB,yCAAyC;EACzC,eAAe;EACf,gFAAgF;EAChF,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,+BAA+B;EAC/B,oDAAoD;EACpD,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,+CAA+C;EAC/C,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sCAAsC;AACtC,2BAA2B,sBAAsB,EAAE;AACnD,2BAA2B,sBAAsB,EAAE;AACnD,2BAA2B,sBAAsB,EAAE;AACnD,2BAA2B,sBAAsB,EAAE;AACnD,2BAA2B,sBAAsB,EAAE;AACnD,2BAA2B,sBAAsB,EAAE;AACnD,2BAA2B,sBAAsB,EAAE;AACnD,2BAA2B,sBAAsB,EAAE;;AAEnD,uBAAuB;AACvB;EACE,qCAAqC;AACvC;;AAEA,oCAAoC,sBAAsB,EAAE;AAC5D,oCAAoC,sBAAsB,EAAE;AAC5D,oCAAoC,sBAAsB,EAAE;AAC5D,oCAAoC,sBAAsB,EAAE;;AAE5D,qBAAqB;AACrB;EACE;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,0BAA0B;EAC1B;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,QAAQ;EACV;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,cAAc;EACd;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA,8CAA8C;EAC9C;IACE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA,8BAA8B;EAC9B;IACE,oBAAoB;IACpB,QAAQ;EACV;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;;EAEA,wCAAwC;EACxC;IACE,kBAAkB;EACpB;;EAEA,6CAA6C;EAC7C;IACE,QAAQ;EACV;EACA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,YAAY;IACZ,YAAY;EACd;EACA;IACE,2BAA2B;IAC3B,6BAA6B;EAC/B;AACF;;AAEA;EACE,uBAAuB;EACvB;IACE,kBAAkB;EACpB;EACA,0CAA0C;EAC1C;IACE,sBAAsB;IACtB,+BAA+B;IAC/B,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["/* ✅ HomePage - Dashboard stylé (ShemsPaie) */\r\n\r\n.home-page {\r\n  color: var(--color-dark-brown);\r\n}\r\n\r\n/* ── Header ── */\r\n.home-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n  padding: 0.25rem 0 0.75rem;\r\n}\r\n\r\n.home-header-left {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.home-greeting {\r\n  font-size: 1.45rem;\r\n  font-weight: 800;\r\n  color: var(--color-dark-brown);\r\n  line-height: 1.2;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.home-avatar {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 42px;\r\n  height: 42px;\r\n  border-radius: 50%;\r\n  background: linear-gradient(135deg, #6d4e36, #9c6b45);\r\n  color: #fff;\r\n  font-size: 0.9rem;\r\n  font-weight: 800;\r\n  letter-spacing: 0.02em;\r\n  flex-shrink: 0;\r\n  box-shadow: 0 3px 10px rgba(109, 78, 54, 0.3);\r\n}\r\n\r\n.home-subtitle {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n  font-size: 13px;\r\n  color: #7a6a5c;\r\n}\r\n\r\n.home-date {\r\n  font-size: 0.82rem;\r\n  color: #9e8e7e;\r\n  font-weight: 500;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.home-header-actions {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  align-items: center;\r\n}\r\n\r\n/* ── Dashboard container ── */\r\n.home-dashboard {\r\n  border: 1px solid rgba(109, 78, 54, 0.1);\r\n  border-top: 3px solid #6d4e36;\r\n  border-radius: 18px;\r\n  padding: 20px;\r\n  background: #ffffff;\r\n  box-shadow: 0 4px 20px rgba(109, 78, 54, 0.08);\r\n}\r\n\r\n/* ── Dashboard header row ── */\r\n.home-dashboard-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.home-dashboard-title {\r\n  font-weight: 700;\r\n  color: var(--color-dark-brown);\r\n  opacity: 0.55;\r\n  text-transform: uppercase;\r\n  font-size: 10px;\r\n  letter-spacing: 0.1em;\r\n}\r\n\r\n/* ── Search bar ── */\r\n.home-search-wrap {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  flex: 0 1 260px;\r\n}\r\n\r\n.home-search-icon {\r\n  position: absolute;\r\n  left: 10px;\r\n  color: #b0a090;\r\n  font-size: 12px;\r\n  pointer-events: none;\r\n}\r\n\r\n.home-search-input {\r\n  width: 100%;\r\n  padding: 6px 30px 6px 28px;\r\n  border: 1.5px solid rgba(109, 78, 54, 0.18);\r\n  border-radius: 10px;\r\n  font-size: 0.82rem;\r\n  color: var(--color-dark-brown);\r\n  background: #fff;\r\n  outline: none;\r\n  transition: border-color 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n.home-search-input:focus {\r\n  border-color: rgba(109, 78, 54, 0.45);\r\n  box-shadow: 0 0 0 3px rgba(109, 78, 54, 0.07);\r\n}\r\n\r\n.home-search-clear {\r\n  position: absolute;\r\n  right: 8px;\r\n  background: none;\r\n  border: none;\r\n  color: #b0a090;\r\n  font-size: 11px;\r\n  cursor: pointer;\r\n  padding: 2px 4px;\r\n  line-height: 1;\r\n  transition: color 0.15s;\r\n}\r\n\r\n.home-search-clear:hover {\r\n  color: #6d4e36;\r\n}\r\n\r\n/* ── Section card ── */\r\n.home-section-card {\r\n  padding: 16px 0 0 0;\r\n  animation: fadeSlideIn 0.3s ease both;\r\n}\r\n\r\n.home-section-card:first-of-type {\r\n  padding-top: 0;\r\n}\r\n\r\n.home-section-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.home-section-header::before,\r\n.home-section-header::after {\r\n  content: '';\r\n  flex: 1;\r\n  height: 1px;\r\n  background: rgba(109, 78, 54, 0.1);\r\n}\r\n\r\n.home-section-title {\r\n  font-weight: 700;\r\n  font-size: 0.72rem;\r\n  color: var(--color-dark-brown);\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  opacity: 0.6;\r\n  white-space: nowrap;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n}\r\n\r\n.home-section-dot {\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 999px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.home-section-count-badge {\r\n  font-size: 0.6rem;\r\n  font-weight: 700;\r\n  color: #fff;\r\n  border-radius: 20px;\r\n  padding: 1px 6px;\r\n  line-height: 1.5;\r\n  opacity: 0.7;\r\n}\r\n\r\n/* ── Tile ── */\r\n.home-tile {\r\n  background: transparent;\r\n  border: 1px solid rgba(109, 78, 54, 0.11);\r\n  border-top: 2.5px solid var(--color-light-brown);\r\n  border-radius: 12px;\r\n  padding: 10px 10px 9px;\r\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.04);\r\n  cursor: pointer;\r\n  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 7px;\r\n  height: 100%;\r\n  animation: fadeSlideIn 0.35s ease both;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n/* ↗ arrow on hover */\r\n.home-tile::after {\r\n  content: '↗';\r\n  position: absolute;\r\n  bottom: 7px;\r\n  right: 9px;\r\n  font-size: 0.75rem;\r\n  font-weight: 700;\r\n  opacity: 0;\r\n  transform: translate(4px, -4px);\r\n  transition: opacity 0.18s ease, transform 0.18s ease;\r\n  color: var(--color-dark-brown);\r\n}\r\n\r\n.home-tile:hover::after {\r\n  opacity: 0.3;\r\n  transform: translate(0, 0);\r\n}\r\n\r\n.home-tile:hover {\r\n  transform: translateY(-4px) scale(1.01);\r\n  box-shadow: 0 10px 24px rgba(109, 78, 54, 0.14);\r\n  border-color: rgba(109, 78, 54, 0.3);\r\n}\r\n\r\n.home-tile:active {\r\n  transform: translateY(-1px) scale(0.99);\r\n  transition-duration: 0.08s;\r\n}\r\n\r\n.home-tile-disabled {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.home-tile-disabled:hover {\r\n  transform: none;\r\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.home-tile-icon {\r\n  width: 34px;\r\n  height: 34px;\r\n  border-radius: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  transition: transform 0.18s ease;\r\n}\r\n\r\n.home-tile:hover .home-tile-icon {\r\n  transform: scale(1.12);\r\n}\r\n\r\n.home-tile-body {\r\n  flex: 1;\r\n}\r\n\r\n.home-tile-title {\r\n  font-weight: 800;\r\n  font-size: 0.8rem;\r\n  color: var(--color-dark-brown);\r\n  line-height: 1.25;\r\n}\r\n\r\n.home-tile-desc {\r\n  font-size: 0.7rem;\r\n  margin-top: 2px;\r\n  color: #a89880;\r\n  line-height: 1.35;\r\n}\r\n\r\n.home-tile-soon {\r\n  margin-top: 4px;\r\n}\r\n\r\n/* ── Animations ── */\r\n@keyframes spin {\r\n  from { transform: rotate(0deg); }\r\n  to   { transform: rotate(360deg); }\r\n}\r\n\r\n@keyframes fadeSlideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n/* Stagger tiles inside each section */\r\n.home-tile:nth-child(1)  { animation-delay: 0.00s; }\r\n.home-tile:nth-child(2)  { animation-delay: 0.04s; }\r\n.home-tile:nth-child(3)  { animation-delay: 0.08s; }\r\n.home-tile:nth-child(4)  { animation-delay: 0.12s; }\r\n.home-tile:nth-child(5)  { animation-delay: 0.16s; }\r\n.home-tile:nth-child(6)  { animation-delay: 0.20s; }\r\n.home-tile:nth-child(7)  { animation-delay: 0.24s; }\r\n.home-tile:nth-child(8)  { animation-delay: 0.28s; }\r\n\r\n/* KPI cards entrance */\r\n.home-kpi-grid > div {\r\n  animation: fadeSlideIn 0.4s ease both;\r\n}\r\n\r\n.home-kpi-grid > div:nth-child(1) { animation-delay: 0.05s; }\r\n.home-kpi-grid > div:nth-child(2) { animation-delay: 0.12s; }\r\n.home-kpi-grid > div:nth-child(3) { animation-delay: 0.19s; }\r\n.home-kpi-grid > div:nth-child(4) { animation-delay: 0.26s; }\r\n\r\n/* ── Responsive ── */\r\n@media (max-width: 768px) {\r\n  .home-greeting {\r\n    font-size: 1.2rem;\r\n  }\r\n  .home-dashboard {\r\n    padding: 14px 12px;\r\n  }\r\n  .home-search-wrap {\r\n    flex: 1 1 100%;\r\n  }\r\n  .home-dashboard-header {\r\n    gap: 0.75rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 575px) {\r\n  /* Header : plus compact */\r\n  .home-header {\r\n    gap: 0.5rem;\r\n  }\r\n  .home-greeting {\r\n    font-size: 1rem;\r\n    gap: 7px;\r\n  }\r\n  .home-avatar {\r\n    width: 34px;\r\n    height: 34px;\r\n    font-size: 0.78rem;\r\n  }\r\n  .home-date {\r\n    display: none;\r\n  }\r\n  .home-header-actions .btn {\r\n    font-size: 0.75rem;\r\n    padding: 4px 8px;\r\n  }\r\n\r\n  /* Dashboard */\r\n  .home-dashboard {\r\n    padding: 12px 10px;\r\n    border-radius: 14px;\r\n  }\r\n\r\n  /* KPI cards : 1 seule colonne sur téléphone */\r\n  .home-kpi-grid {\r\n    grid-template-columns: 1fr !important;\r\n    gap: 10px !important;\r\n  }\r\n\r\n  /* Tiles : icône plus petite */\r\n  .home-tile {\r\n    padding: 8px 8px 7px;\r\n    gap: 5px;\r\n  }\r\n  .home-tile-icon {\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 8px;\r\n  }\r\n  .home-tile-icon svg {\r\n    width: 18px;\r\n    height: 18px;\r\n  }\r\n  .home-tile-title {\r\n    font-size: 0.76rem;\r\n  }\r\n  .home-tile-desc {\r\n    display: none;\r\n  }\r\n\r\n  /* Section header : texte plus compact */\r\n  .home-section-title {\r\n    font-size: 0.65rem;\r\n  }\r\n\r\n  /* Sélecteur période : inputs plus compacts */\r\n  .home-period-bar {\r\n    gap: 6px;\r\n  }\r\n  .home-period-inputs input[type=\"date\"] {\r\n    font-size: 0.72rem !important;\r\n    padding: 4px 5px !important;\r\n    min-width: 0;\r\n    width: 100px;\r\n  }\r\n  .home-period-inputs span:first-child {\r\n    padding: 4px 7px !important;\r\n    font-size: 0.68rem !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 400px) {\r\n  /* Très petits écrans */\r\n  .home-tile-title {\r\n    font-size: 0.72rem;\r\n  }\r\n  /* Sélecteur période : inputs en colonne */\r\n  .home-period-inputs {\r\n    flex-direction: column;\r\n    align-items: stretch !important;\r\n    width: 100%;\r\n  }\r\n  .home-period-inputs input[type=\"date\"] {\r\n    width: 100% !important;\r\n  }\r\n  .home-period-inputs span:nth-child(3) {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
